import { render, staticRenderFns } from "./learnerresults.vue?vue&type=template&id=7c5a388b&scoped=true&"
import script from "./learnerresults.vue?vue&type=script&lang=ts&"
export * from "./learnerresults.vue?vue&type=script&lang=ts&"
import style0 from "./learnerresults.vue?vue&type=style&index=0&id=7c5a388b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a388b",
  null
  
)

export default component.exports